import { apiCall } from "./servicesCall";

export const EVENTS_SERVICES = {
  getUsers(data) {
    return apiCall("/events/users", data);
  },
  getUsersProfile(data) {
    return apiCall("/events/users/profile", data);
  },
  getUsersTotal(data) {
    return apiCall("/events/users/total", data);
  },
  loginMagicLink(data) {
    return apiCall("/events/users/login/link", data);
  },
  exportUserCSV(data) {
    return apiCall("/events/users/csv", data);
  },

  getEvents(data) {
    return apiCall("/events", data);
  },

  getEventsChats(data) {
    return apiCall("/events/chats", data);
  },
  getEventsParticipants(data) {
    return apiCall("/events/participants", data);
  },
  getEventsChatsDelete(data) {
    return apiCall("/events/chats/delete", data);
  },

  deleteEvent(data) {
    return apiCall("/events/delete/event", data);
  },

  updateEventType(data) {
    return apiCall("/events/update/type", data);
  },
  getDashboard(data) {
    return apiCall("/events/dashboard", data);
  },
  addParticipant(data) {
    return apiCall("/events/participant/add", data);
  },
  exportEventCSV(data) {
    return apiCall("/events/csv", data);
  },
  exportInvestorCSV(data) {
    return apiCall("/events/investor/csv", data);
  },
  getOrgazination(data) {
    return apiCall("/events/orgazination", data);
  },
  createNewOrgazination(data) {
    return apiCall("/events/orgazination/create", data);
  },
  exportOrganizationCSV(data) {
    return apiCall("/events/orgazination/csv", data);
  },
  updateSubscription(data) {
    return apiCall("/events/orgazination/subscription/update", data);
  },
  getBillingSetup(data) {
    return apiCall("/events/orgazination/billing/setup", data);
  },
  updateBillingSetup(data) {
    return apiCall("/events/orgazination/billing/setup/update", data);
  },
  getTransitionsList(data) {
    return apiCall("/events/orgazination/transitions/list", data);
  },
  getTransitionsAll(data) {
    return apiCall("/events/orgazination/transitions/all", data);
  },
  getPlans(data) {
    return apiCall("/events/orgazination/plans", data);
  },
  getOrgProfile(data) {
    return apiCall("/events/orgazination/profile", data);
  },
  getOrgTeams(data) {
    return apiCall("/events/orgazination/teams", data);
  },
  addOrgTeam(data) {
    return apiCall("/events/orgazination/teams/add", data);
  },
  roleOrgTeam(data) {
    return apiCall("/events/orgazination/teams/role", data);
  },
  removeOrgTeam(data) {
    return apiCall("/events/orgazination/teams/remove", data);
  },
  getWatchlist(data) {
    return apiCall("/events/watchlist", data);
  },

  // stocks
  getStocks(data) {
    return apiCall("/events/stocks", data);
  },
  getStocksOrgs(data) {
    return apiCall("/events/stocks/orgazination", data);
  },
  mergeStock(data) {
    return apiCall("/events/stocks/merge", data);
  },
  addStockOrg(data) {
    return apiCall("/events/stocks/add/orgazination", data);
  },
  getNews(data) {
    return apiCall("/events/orgazination/news/list", data);
  },
  addOrgNews(data) {
    return apiCall("/events/orgazination/news/add", data);
  },
  removeOrgNews(data) {
    return apiCall("/events/orgazination/news/remove", data);
  },
  syncOrgNews(data) {
    return apiCall("/events/orgazination/news/sync", data);
  },
  newsChart(data) {
    return apiCall("/events/orgazination/news/chart", data);
  },
  viewSurvey(data) {
    return apiCall("/events/survey/view", data);
  },
};
